// extracted by mini-css-extract-plugin
export var headerCell = "_1j-1";
export var loadingSpinnerContainer = "_1j-4";
export var rowWrapper = "_1j-3";
export var standaloneTable = "_1j-5";
export var table = "_1j-0";
export var white = "_1j-2";